<template>
	<v-card>
		<v-card elevation="2" tile style="">
			<v-card-title
				class="headline elevation-2 font-weight-light primary secondary mb-4"
			>
				{{ item.title }}
				<v-spacer />
				<v-btn @click="$emit('submit', undefined)" icon>
					<v-icon>mdi-close-circle</v-icon>
				</v-btn>
			</v-card-title>
			<!-- <v-card-title v-text='item.title' /> -->
			<v-card-text v-if="item.files.length">
				<h3>File attachments</h3>
				<v-row>
					<v-col
						:key="index"
						cols="auto"
						style="min-width: 200px"
						v-for="(file, index) in item.files"
					>
						<FileItem v-bind="file" @click.native="openFile(file.path)" />
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-text v-html="item.text" />
		</v-card>
		<v-divider />

		<v-card-actions style="background-color: lightgray !important">
			<v-spacer />
			<v-btn text color="primary" @click="$emit('submit')"
				><v-icon left>mdi-close</v-icon>Close</v-btn
			>
		</v-card-actions>
	</v-card>
</template>

<script>
import DeleteButton from '@/components/ui/DeleteButton'
import SaveButton from '@/components/ui/SaveButton'

import FileItem from '@/components/n-collections/n-items/FileItem'

export default {
	name: 'NewsDialog',
	props: {
		item: {
			type: Object,
			default: {
				title: '',
				text: '',
				files: [],
			},
		},
	},
	components: {
		DeleteButton,
		SaveButton,
		FileItem
	},
		methods: {
		openFile(path) {
			window.open(path, '_blank')
		},
	},
}
</script>

<style lang="stylus">
.vuedl-layout__closeBtn
	display none
</style>